import { render, staticRenderFns } from "./service-list.vue?vue&type=template&id=3261fd5d&scoped=true&"
import script from "./service-list.vue?vue&type=script&lang=js&"
export * from "./service-list.vue?vue&type=script&lang=js&"
import style0 from "./service-list.vue?vue&type=style&index=0&id=3261fd5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3261fd5d",
  null
  
)

export default component.exports